import React, { useState, useEffect, useRef } from "react";
import "./ContactUs.css";

import CommonFooter from "../../components/footer/CommonFooter";
import Breadcrumb from "../../components/breadcrumb";
import CommonButton from "../../components/button/CommonButton";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { imagePath } from "../../constants/imagePath";
import { useLocation } from "react-router-dom";

const ContactUs = () => {
  const location = useLocation();
  const inquiryAppliedRef = useRef(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contactNumber: "",
    userType: "Wholesaler",
    subject: "",
    message: "",
  });

  useEffect(() => {
    const s = location.state;
    if (!s?.productInquiry || inquiryAppliedRef.current) return;
    const subject = typeof s.subject === "string" ? s.subject : "";
    const message = typeof s.message === "string" ? s.message : "";
    if (!subject && !message) return;
    inquiryAppliedRef.current = true;
    setFormData((prev) => ({
      ...prev,
      ...(subject ? { subject } : {}),
      ...(message ? { message } : {}),
    }));
  }, [location.state]);

  useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "auto",
  });
}, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
    // You can add API call here
  };

  return (
    <div className="contact-us">
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "Contact Us",
            isActive: true,
          },
        ]}
      />
      <main className="contact-us__main">
        <div className="contact-us__container">
          <div className="contact-us__content">
            <div className="contact-us__left">
              <h2 className="contact-us__section-title">
                Other Ways To Connect
              </h2>

              <div className="contact-us__info-cards">
                <div className="contact-us__info-card">
                  <div className="contact-us__info-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-us__info-content">
                    <h3 className="contact-us__info-label">Contact</h3>
                    <p className="contact-us__info-text">+91 7490026756</p>
                  </div>
                </div>

                <div className="contact-us__info-card">
                  <div className="contact-us__info-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-us__info-content">
                    <h3 className="contact-us__info-label">Email</h3>
                    <p className="contact-us__info-text">
                      siddharthfashion1037@gmail.com
                    </p>
                  </div>
                </div>
              </div>

              <div className="contact-us__full-map-section">
                <h2 className="contact-us__section-title">
                  Find Us On Google Maps
                </h2>
                <div className="contact-us__map-card">
                  <div className="contact-us__map-info-card">
                    <div className="contact-us__map-content-row">
                      <div className="contact-us__map-left-section">
                        <h3 className="contact-us__map-business-name">
                          Yug Mantra
                        </h3>
                        <p className="contact-us__map-address">
                          Shop No. H-569/70/71, Global Textile Market, Near
                          Sahara Darawaja, Surat-395010
                        </p>
                      </div>
                      <div className="contact-us__map-right-section">
                        <a
                          href="https://www.google.com/maps/dir/?api=1&destination=21.195438947721257,72.8479056689379"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="contact-us__map-directions"
                        >
                          <div className="contact-us__map-directions-icon">
                            <img src={imagePath.direction} alt="Directions" />
                          </div>
                          <span className="contact-us__map-directions-text">
                            Directions
                          </span>
                        </a>
                      </div>
                    </div>
                    <a
                      href="https://www.google.com/maps/place/21.195438947721257,72.8479056689379"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-us__map-view-larger"
                    >
                      View larger map
                    </a>
                  </div>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.123456789!2d72.8479056689379!3d21.195438947721257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjHCsDExJzQzLjYiTiA3MsKwNTAnNTIuNSJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Yug Mantra"
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="contact-us__right">
              <h2 className="contact-us__section-title">
                Get In Touch With Us
              </h2>

              <form className="contact-us__form" onSubmit={handleSubmit}>
                <div className="contact-us__form-group">
                  <label htmlFor="fullName" className="contact-us__form-label">
                    Full Name*
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className="contact-us__form-input"
                    placeholder="Enter Full Name"
                    required
                  />
                </div>

                <div className="contact-us__form-row">
                  <div className="contact-us__form-group">
                    <label htmlFor="email" className="contact-us__form-label">
                      Email*
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="contact-us__form-input"
                      placeholder="Enter Email Address"
                      required
                    />
                  </div>

                  <div className="contact-us__form-group">
                    <label
                      htmlFor="contactNumber"
                      className="contact-us__form-label"
                    >
                      Contact Number*
                    </label>
                    <input
                      type="tel"
                      id="contactNumber"
                      name="contactNumber"
                      value={formData.contactNumber}
                      onChange={handleInputChange}
                      className="contact-us__form-input"
                      placeholder="Enter Contact Number"
                      required
                    />
                  </div>
                </div>

                <div className="contact-us__form-group">
                  <label htmlFor="userType" className="contact-us__form-label">
                    User Type*
                  </label>
                  <select
                    id="userType"
                    name="userType"
                    value={formData.userType}
                    onChange={handleInputChange}
                    className="contact-us__form-select"
                    required
                  >
                    <option value="wholesaler">Wholesaler</option>
                    <option value="retailer">Retailer</option>
                  </select>
                </div>

                <div className="contact-us__form-group">
                  <label htmlFor="subject" className="contact-us__form-label">
                    Subject*
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="contact-us__form-input"
                    placeholder="Enter Subject"
                    required
                  />
                </div>

                <div className="contact-us__form-group">
                  <label htmlFor="message" className="contact-us__form-label">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="contact-us__form-textarea"
                    placeholder="Enter Message..."
                    rows="4"
                  />
                </div>

                <div className="contact-us__form-submit">
                  <CommonButton
                    type="submit"
                    title="Submit"
                    customClassName="contact-us__submit-btn"
                  />
                </div>
              </form>
            </div>
          </div>

          {/* Full-width Google Maps section */}
        </div>
      </main>

      <CommonFooter />
    </div>
  );
};

export default ContactUs;
